Promise = require 'bluebird'

module.exports = class MembersLoader
  # server limit for members is 100
  PAGE_SIZE: 50

  constructor: (enterprise, opts = {}) ->
    @enterprise = enterprise
    @filter = opts.filterStringBuilder?.toString()
    @items = []
    @totalLength = 0
    @lengthOfPending = 0
    @loadAsSelected = false
    @nextPageStartIndex = 1
    @hasNext = true
    @sortField = opts.sortField ? 'fullName'
    @sortOrder = opts.sortOrder ? 'ascending'

  _load: (startIndex) ->
    query =
      startIndex: startIndex
      count: MembersLoader::PAGE_SIZE
      sortBy: @sortField
      sortOrder: @sortOrder
    query.filter = @filter if @filter

    # store promise so we can cancel it
    @_loadPromise = @enterprise.loadPageOfMembers(query)
      .spread (members, { totalResults }) =>
        for m in members
          @items.push(m)
        @totalLength = totalResults
        @lengthOfPending = @totalLength - @items.length
        members

  loadNext: ->
    return Promise.resolve([]) unless @hasNext

    @_load(@nextPageStartIndex).tap (members) =>
      @nextPageStartIndex += members.length
      @hasNext = @items.length < @totalLength

  loadAll: (afterEachPage) ->
    return Promise.resolve([]) unless @hasNext

    loads = for nextStartIndex in [@nextPageStartIndex..@totalLength] by MembersLoader::PAGE_SIZE
      @_load(nextStartIndex).tap(afterEachPage)

    Promise.all(loads)
    .then =>
      @nextPageStartIndex = @totalLength + 1
      @hasNext = false
      @lengthOfPending = 0
      return

  abortLoad: ->
    @_loadPromise?.cancellable().cancel()



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/members-loader.coffee